import apiClient from './api';

export const respuestaService = {
  // Listar todas las respuestas
  getAllRespuestas: async () => {
    const response = await apiClient.get('/respuestas');
    return response.data;
  },

  // Listar respuestas por usuario
  getRespuestasByUsuario: async (usuarioId) => {
    const response = await apiClient.get(`/respuestas/usuario/${usuarioId}`);
    return response.data;
  },

  // Listar respuestas por pregunta
  getRespuestasByPregunta: async (preguntaId) => {
    const response = await apiClient.get(`/respuestas/pregunta/${preguntaId}`);
    return response.data;
  },

  // Crear nueva respuesta
  createRespuesta: async (respuestaData) => {
    const response = await apiClient.post('/respuestas', respuestaData);
    return response.data;
  },

  // Actualizar respuesta
  updateRespuesta: async (id, respuestaData) => {
    const response = await apiClient.put(`/respuestas/${id}`, respuestaData);
    return response.data;
  },

  // Eliminar respuesta
  deleteRespuesta: async (id) => {
    const response = await apiClient.delete(`/respuestas/${id}`);
    return response.data;
  },

  // Enviar múltiples respuestas de un examen (bulk)
  enviarRespuestasExamen: async (respuestas) => {
    // respuestas es un array de objetos con la estructura:
    // { usuarioId, examenId, preguntaId, opcionId, correcta }
    const promises = respuestas.map(respuesta => 
      apiClient.post('/respuestas', {
        usuarioId: respuesta.usuarioId,
        examenId: respuesta.examenId,
        preguntaId: respuesta.preguntaId,
        opcionId: respuesta.opcionId,
        correcta: respuesta.correcta
      })
    );
    const results = await Promise.all(promises);
    return results.map(r => r.data);
  },

  // Guardar progreso del examen
  guardarProgresoExamen: async (progresoData) => {
    // progresoData: { usuarioId, examenId, preguntaId, opcionId }
    const response = await apiClient.post('/respuestas/progreso', progresoData);
    return response.data;
  },

  // Eliminar respuesta de progreso
  eliminarProgresoRespuesta: async (usuarioId, preguntaId) => {
    const response = await apiClient.delete(`/respuestas/progreso/${usuarioId}/${preguntaId}`);
    return response.data;
  },

  // Obtener progreso existente de un examen
  obtenerProgresoExamen: async (usuarioId, examenId) => {
    const response = await apiClient.get(`/respuestas/progreso/${usuarioId}/${examenId}`);
    return response.data;
  },

  // Obtener respuestas correctas de un usuario
  getRespuestasCorrectasByUsuario: async (usuarioId) => {
    const response = await apiClient.get(`/respuestas-correctas/usuario/${usuarioId}`);
    return response.data;
  },

  // Obtener resultado final del examen con nivel de rendimiento
  getResultadoFinalExamen: async (usuarioId, examenId, totalPreguntas) => {
    const response = await apiClient.get(`/respuestas-correctas/usuario/${usuarioId}/examen/${examenId}/resultado-final`, {
      params: { totalPreguntas }
    });
    return response.data;
  },
};

export default respuestaService;
